import { render, staticRenderFns } from "./card-cedrow-benefits-policy.vue?vue&type=template&id=9b27e58e&scoped=true&"
import script from "./card-cedrow-benefits-policy.vue?vue&type=script&lang=js&"
export * from "./card-cedrow-benefits-policy.vue?vue&type=script&lang=js&"
import style0 from "./card-cedrow-benefits-policy.vue?vue&type=style&index=0&id=9b27e58e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b27e58e",
  null
  
)

export default component.exports